import { useEffect, useState } from "react";
import { api } from "../lib/api";
import BlogCard from "../components/BlogCard";

export default function News() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="news-page" className="text-white">
      <section className="max-w-7xl mx-auto px-5 md:px-8 pt-16 md:pt-24">
        <div className="text-xs uppercase tracking-[0.35em] text-axe-tangerine font-bold">
          Newsroom
        </div>
        <h1 className="mt-3 font-display font-black text-4xl sm:text-5xl lg:text-6xl">
          News & <span className="text-axe-purple">Highlights</span>
        </h1>
        <p className="mt-5 text-neutral-400 text-base sm:text-lg max-w-2xl">
          Roster moves, tournament recaps, and deep-dives from inside the AXE house.
        </p>
      </section>

      <section className="max-w-7xl mx-auto px-5 md:px-8 mt-12">
        {loading ? (
          <div className="text-neutral-400" data-testid="news-loading">Loading…</div>
        ) : posts.length === 0 ? (
          <div className="text-neutral-500 border border-axe-border rounded-2xl p-8 text-center" data-testid="news-empty">
            Nothing here yet. Check back soon.
          </div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {posts.map((p) => <BlogCard key={p.id} post={p} />)}
          </div>
        )}
      </section>
    </div>
  );
}
